import React from "react";
import { ClientAssetDataStructure } from "../types";
import { List, ListItem, Button } from "@mui/material";
import { setActiveSpanByName } from "./store/reducers/deviceLinkingAppStoreSlice";
import { useAppDispatch } from "./store/hooks";

type StructureActiveObjectDetailedInfoProps = {
    className?: string;
    activeStructure: ClientAssetDataStructure;
};

export default function StructureActiveObjectDetailedInfo(props: StructureActiveObjectDetailedInfoProps): JSX.Element {
    const dispatch = useAppDispatch();
    return (
        <div className={props.className}>
            <h1>Structure Selected</h1>
            <List>
                <ListItem>
                    <b>Structure:</b> {props.activeStructure.structure_name}
                </ListItem>
                <ListItem>
                    <b>Minimum Conductor Elevation:</b> {props.activeStructure.min_cond_elevation}
                </ListItem>
                <ListItem>
                    <b>Ground Elevation:</b> {props.activeStructure.ground_elevation}
                </ListItem>
            </List>
            <h1>Attached to Spans</h1>
            {props.activeStructure.spans.map((span) => (
                <Button key={span} onClick={() => dispatch(setActiveSpanByName(span))}>
                    {span}
                </Button>
            ))}
        </div>
    );
}
